export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      solutions: "Solutions",
      newalbert: "NewAlbert AI",
      aiKnowledge: "AI Knowledge Management",
      collaboration: "Collaboration & Sharing",
      contact: "Contact",
    },
    footer: {
      addressTitle: "European Office",
      presentedBy: "Presented by Albertsen Group, LLC",
      rights: "All rights reserved.",
    },
    home: {
      heroTitle: "Albertsen Group",
      heroTagline: "Making next-generation collaboration software and services for Climate research and Sustainability.",
      heroSubtitle1: "Advancing the Frontiers of Academic Research with AI-Powered Knowledge Management",
      heroSubtitle2: "Your trusted partner in academic research.",
      whoAreWeTitle: "Who are we?",
      whoAreWeBullet1: "Albertsen Group, LLC is a holding company that invests in AI-Powered knowledge management platforms. The company owns and manages a dedicated software development subsidiary that designs and builds these platforms.",
      whoAreWeBullet2: "We are pleased to announce the opening of our European office in Denmark in 2025.",
      whatWeDoTitle: "What do we do?",
      whatWeDoBullet1: "Albertsen Group, LLC is building AI technology that is revolutionizing the way we interact with information from ever-increasing repositories of documents and data.",
      whatWeDoBullet2: "NewAlbert is an AI-driven Knowledge Management system that is a true research partner.",
      whatWeDoBullet3: "AI transforms the efficiency and accuracy of document searches, analysis, and insights – addressing the challenges posed by traditional methods.",
      galleryTitle: "Central Media Gallery",
      gallerySubtitle: "Explore our research environments, climate technologies, and AI concepts managed directly via the CMS.",
    },
    about: {
      title: "About Albertsen Group",
      subtitle: "Academic Corporate Classic",
      established: "Established 2022",
      introTitle: "AI-Powered Knowledge Management Platforms",
      introText: "Albertsen Group, LLC operates at the intersection of academic rigor and next-generation artificial intelligence. As a premier holding company, we focus on funding, designing and advanced knowledge management platforms that serve researchers and universities.",
      subsidiaryTitle: "Dedicated Development",
      subsidiaryText: "Our dedicated software development subsidiary is staffed by leading engineers and researchers who build high-performance, secure, and intuitive platforms. By maintaining full vertical integration, we ensure that our software meets the highest standards of academic integrity and technological excellence.",
      officeTitle: "European Expansion",
      officeText: "Albertsen Group was established in the United States in 2022. In 2025, Albertsen Group established its European headquarters in Denmark. This strategic location places us in one of the world's leading hubs for research and academic collaboration, allowing us to partner closely with universities and research institutes.",
    },
    newalbert: {
      title: "NewAlbert an AI-Powered Solution",
      subtitle: "An AI-driven Knowledge Management system that is a true Research Partner",
      welcome: "Welcome to NewAlbert",
      coreTechTitle: "The Core Technology for NewAlbert:",
      ragTitle: "Retrieval Augmented Generation (RAG)",
      ragText: "A next-generation Retrieval-Augmented Generation (RAG) system that transforms ingested academic documents into a powerful Knowledge Graph. It understands the relationship between concepts, not just their definitions.",
      reasoningTitle: "AI Reasoning Engine",
      reasoningText: "Interprets complex queries, synthesizes graph-level information, and provides nuanced, natural language answers with full academic citations.",
      differentTitle: "What makes our solution different",
      differentText: "NewAlbert is built to work the way research actually works. Ideas do not exist in isolation; they connect to each other. Our system understands both the small details (specific facts, names, and relationships between concepts) and the bigger picture (broad themes and patterns across a field). This means it does not just find research documents for you, it actually understands how they relate to one another, retrieving the most relevant information needed.",
      beyondSearch: "By leveraging the latest AI capabilities (such as long-context windows for deep document analysis and advanced reasoning for synthesizing complex theories), NewAlbert moves beyond a simple 'search' tool into a true research partner.",
    },
    aiKnowledge: {
      title: "AI Knowledge Management",
      subtitle: "Revolutionizing Information Interaction",
      intro: "Albertsen Group builds AI technology that is revolutionizing the way researchers, institutions, and enterprises interact with information from ever-increasing repositories of documents and data.",
      challengeTitle: "The Traditional Challenge",
      challengeText: "Traditional search methods rely on keyword matching, which often misses critical context, synonyms, and conceptual links. Researchers waste valuable hours filtering through irrelevant papers or failing to find obscure but vital connections.",
      solutionTitle: "Our AI-Powered Solution",
      solutionText: "By combining advanced Natural Language Processing (NLP) with semantic indexing, our platforms ingest massive volumes of unstructured data—including PDFs, research papers, lab notes, and historical records—and structure them into an easily navigable, highly connected knowledge base.",
      benefits: [
        {
          title: "Semantic Understanding",
          desc: "Our AI understands the intent behind queries, delivering highly relevant results even when the exact keywords are not present."
        },
        {
          title: "Automated Synthesis",
          desc: "Instead of just listing documents, the system synthesizes findings across multiple papers to provide direct answers."
        },
        {
          title: "Context Preservation",
          desc: "Maintains the context of figures, tables, and citations, ensuring that extracted data is accurate and reliable."
        }
      ]
    },
    collaboration: {
      title: "Collaboration & Knowledge Sharing",
      subtitle: "Connecting Universities Worldwide",
      intro: "Albertsen Group facilitates seamless knowledge exchange and collaboration among academic institutions, research labs, and scientists globally.",
      items: [
        {
          term: "Lab Knowledge Base",
          desc: "Preserve institutional knowledge from alumni theses, lab reports, and internal documents so it does not walk out the door when researchers move on."
        },
        {
          term: "Expertise Mapping",
          desc: "Identify which faculty members and researchers have relevant expertise for a given topic, enabling better internal and external collaboration."
        },
        {
          term: "Conference Paper Briefings",
          desc: "Quickly brief researchers on all relevant papers, trends, and speaker backgrounds before they attend international conferences."
        }
      ],
      academicHeading: "A Trusted Academic Network",
      academicText: "Our tools are designed to break down institutional silos. By creating secure, shared knowledge repositories, universities can collaborate on climate research, sustainability projects, and technological breakthroughs with unprecedented speed and efficiency."
    },
    contact: {
      title: "Contact Albertsen Group",
      subtitle: "Get in Touch with Our Team",
      formTitle: "Send Us a Message",
      name: "Full Name",
      phone: "Phone Number",
      email: "Email Address",
      description: "Project Description / Inquiry",
      submit: "Submit Inquiry",
      submitting: "Sending...",
      success: "Thank you! Your message has been sent successfully. We will get back to you shortly.",
      error: "An error occurred while submitting the form. Please try again.",
      officeInfo: "Office Information",
      address: "Filial af Albertsen Group, LLC",
      street: "Dr. Olgas Vej 30",
      city: "DK-2000 Frederiksberg",
      country: "Denmark",
      cvr: "CVR# 45973646",
      phoneLabel: "Phone",
      emailLabel: "Email",
      phoneVal: "+1 (617) 487-2008 (USA)",
      emailVal: "Info@albert-grp.com",
      contactPersonLabel: "Contact Person",
      contactPersonVal: "Peter Albertsen",
    },
    errors: {
      forbiddenTitle: "403 - Forbidden",
      forbiddenText: "You do not have permission to access this resource. Please contact the administrator if you believe this is an error.",
      notFoundTitle: "404 - Page Not Found",
      notFoundText: "The page you are looking for does not exist or has been moved.",
      backHome: "Back to Home",
    }
  },
  da: {
    nav: {
      home: "Forside",
      about: "Om Os",
      solutions: "Løsninger",
      newalbert: "NewAlbert AI",
      aiKnowledge: "AI Vidensstyring",
      collaboration: "Samarbejde & Vidensdeling",
      contact: "Kontakt",
    },
    footer: {
      addressTitle: "Europæisk Kontor",
      presentedBy: "Præsenteret af Albertsen Group, LLC",
      rights: "Alle rettigheder forbeholdes.",
    },
    home: {
      heroTitle: "Albertsen Group",
      heroTagline: "Skaber næste generations samarbejdssoftware og tjenester til klimaforskning og bæredygtighed.",
      heroSubtitle1: "Fremme af grænserne for akademisk forskning med AI-drevet vidensstyring",
      heroSubtitle2: "Din betroede partner i akademisk forskning.",
      whoAreWeTitle: "Hvem er vi?",
      whoAreWeBullet1: "Albertsen Group, LLC er et holdingselskab, der investerer i AI-baserede vidensstyringsplatforme. Virksomheden ejer og leder et dedikeret softwareudviklingsdatterselskab, der designer og bygger disse platforme.",
      whoAreWeBullet2: "Det er os en glæde at annoncere åbningen af vores europæiske kontor i Danmark i 2025.",
      whatWeDoTitle: "Hvad gør vi?",
      whatWeDoBullet1: "Albertsen Group, LLC bygger AI-teknologi, der revolutionerer måden, vi interagerer med information fra stadigt voksende lagre af dokumenter og data.",
      whatWeDoBullet2: "NewAlbert er et AI-drevet vidensstyringssystem, der er en sand forskningspartner.",
      whatWeDoBullet3: "AI transformerer effektiviteten og nøjagtigheden af dokumentsøgninger, analyser og indsigt – og adresserer de udfordringer, som traditionelle metoder udgør.",
      galleryTitle: "Centralt Mediegalleri",
      gallerySubtitle: "Udforsk vores forskningsmiljøer, klimateknologier og AI-koncepter, der administreres direkte via CMS.",
    },
    about: {
      title: "Om Albertsen Group",
      subtitle: "Akademisk Corporate Klassiker",
      established: "Etableret 2022",
      introTitle: "AI-drevne vidensstyringsplatforme",
      introText: "Albertsen Group, LLC opererer i krydsfeltet mellem akademisk stringens og næste generations kunstige intelligens. Som et førende holdingselskab fokuserer vi på at finansiere, designe og avancerede vidensstyringsplatforme, der tjener forskere og universiteter.",
      subsidiaryTitle: "Dedikeret Udvikling",
      subsidiaryText: "Vores dedikerede softwareudviklingsdatterselskab er besat af førende ingeniører og forskere, der bygger højtydende, sikre og intuitive platforme. Ved at opretholde fuld vertikal integration sikrer vi, at vores software lever op til de højeste standarder for akademisk integritet og teknologisk ekspertise.",
      officeTitle: "Europæisk Ekspansion",
      officeText: "Albertsen Group blev etableret i USA i 2022. I 2025 etablerede Albertsen Group sit europæiske hovedkvarter i Danmark. Denne strategiske placering placerer os i et af verdens førende centre for forskning og akademisk samarbejde, hvilket giver os mulighed for at samarbejde tæt med universiteter og forskningsinstitutter.",
    },
    newalbert: {
      title: "NewAlbert en AI-drevet løsning",
      subtitle: "Et AI-drevet vidensstyringssystem, der er en sand forskningspartner",
      welcome: "Velkommen til NewAlbert",
      coreTechTitle: "Kerneteknologien bag NewAlbert:",
      ragTitle: "Retrieval Augmented Generation (RAG)",
      ragText: "Et næste generations Retrieval-Augmented Generation (RAG) system, der transformerer indlæste akademiske dokumenter til en kraftfuld vidensgraf. Det forstår forholdet mellem koncepter, ikke kun deres definitioner.",
      reasoningTitle: "AI Ræsonnementsmotor",
      reasoningText: "Fortolker komplekse forespørgsler, syntetiserer information på grafniveau og giver nuancerede svar på naturligt sprog med fulde akademiske kildehenvisninger.",
      differentTitle: "Hvad gør vores løsning anderledes",
      differentText: "NewAlbert er bygget til at fungere på samme måde, som forskning faktisk fungerer. Ideer eksisterer ikke i isolation; de forbinder sig med hinanden. Vores system forstår både de små detaljer (specifikke fakta, navne og relationer mellem begreber) og det større billede (brede temaer og mønstre på tværs af et felt). Det betyder, at det ikke bare finder forskningsdokumenter for dig, det forstår faktisk, hvordan de relaterer til hinanden, og henter de mest relevante oplysninger, der er brug for.",
      beyondSearch: "Ved at udnytte de nyeste AI-kapaciteter (såsom lange kontekstvinduer til dyb dokumentanalyse og avanceret ræsonnement til syntetisering af komplekse teorier) bevæger NewAlbert sig ud over et simpelt 'søgeværktøj' til en sand forskningspartner.",
    },
    aiKnowledge: {
      title: "AI Vidensstyring",
      subtitle: "Revolutionerende Informationsinteraktion",
      intro: "Albertsen Group bygger AI-teknologi, der revolutionerer måden, hvorpå forskere, institutioner og virksomheder interagerer med information fra stadigt voksende lagre af dokumenter og data.",
      challengeTitle: "Den Traditionelle Udfordring",
      challengeText: "Traditionelle søgemetoder afhænger af søgeordsmatchning, som ofte overser kritisk kontekst, synonymer og konceptuelle links. Forskere spilder værdifulde timer på at filtrere irrelevante artikler eller mislykkes med at finde obskure, men vitale forbindelser.",
      solutionTitle: "Vores AI-Drevne Løsning",
      solutionText: "Ved at kombinere avanceret Natural Language Processing (NLP) med semantisk indeksering indlæser vores platforme enorme mængder ustrukturerede data—herunder PDF'er, forskningsartikler, laboratorienotater og historiske optegnelser—og strukturerer dem i en letnavigerbar, tæt forbundet vidensbase.",
      benefits: [
        {
          title: "Semantisk Forståelse",
          desc: "Vores AI forstår hensigten bag forespørgsler og leverer yderst relevante resultater, selv når de nøjagtige søgeord ikke er til stede."
        },
        {
          title: "Automatiseret Syntese",
          desc: "I stedet for blot at liste dokumenter, syntetiserer systemet resultater på tværs af flere artikler for at give direkte svar."
        },
        {
          title: "Kontekstbevarelse",
          desc: "Bevarer konteksten for figurer, tabeller og citater, hvilket sikrer, at de udtrukne data er nøjagtige og pålidelige."
        }
      ]
    },
    collaboration: {
      title: "Samarbejde & Vidensdeling",
      subtitle: "Forbindelse af Universiteter over Hele Verden",
      intro: "Albertsen Group faciliterer problemfri vidensudveksling og samarbejde mellem akademiske institutioner, forskningslaboratorier og forskere globalt.",
      items: [
        {
          term: "Lab Vidensbase",
          desc: "Bevar institutionel viden fra alumni-afhandlinger, laboratorierapporter og interne dokumenter, så den ikke forsvinder, når forskere rejser videre."
        },
        {
          term: "Ekspertisekortlægning",
          desc: "Identificer hvilke fakultetsmedlemmer og forskere, der har relevant ekspertise inden for et givet emne, hvilket muliggør bedre internt og eksternt samarbejde."
        },
        {
          term: "Briefinger om Konferencerapporter",
          desc: "Brief hurtigt forskere om alle relevante artikler, trends og talerbaggrunde, før de deltager i internationale konferencer."
        }
      ],
      academicHeading: "Et Betroet Akademisk Netværk",
      academicText: "Vores værktøjer er designet til at nedbryde institutionelle siloer. Ved at skabe sikre, delte videnslagre kan universiteter samarbejde om klimaforskning, bæredygtighedsprojekter og teknologiske gennembrud med hidtil uset hastighed og effektivitet."
    },
    contact: {
      title: "Kontakt Albertsen Group",
      subtitle: "Kom i Kontakt med Vores Team",
      formTitle: "Send Os en Besked",
      name: "Fuldt Navn",
      phone: "Telefonnummer",
      email: "E-mailadresse",
      description: "Projektbeskrivelse / Forespørgsel",
      submit: "Send Forespørgsel",
      submitting: "Sender...",
      success: "Tak! Din besked er blevet sendt med succes. Vi vender tilbage til dig hurtigst muligt.",
      error: "Der opstod en fejl under afsendelsen af formularen. Prøv venligst igen.",
      officeInfo: "Kontorinformation",
      address: "Filial af Albertsen Group, LLC",
      street: "Dr. Olgas Vej 30",
      city: "DK-2000 Frederiksberg",
      country: "Danmark",
      cvr: "CVR# 45973646",
      phoneLabel: "Telefon",
      emailLabel: "E-mail",
      phoneVal: "+1 (617) 487-2008 (USA)",
      emailVal: "Info@albert-grp.com",
      contactPersonLabel: "Kontaktperson",
      contactPersonVal: "Peter Albertsen",
    },
    errors: {
      forbiddenTitle: "403 - Forbudt",
      forbiddenText: "Du har ikke tilladelse til at tilgå denne ressource. Kontakt venligst administratoren, hvis du mener, dette er en fejl.",
      notFoundTitle: "404 - Siden Blev Ikke Fundet",
      notFoundText: "Siden, du leder efter, eksisterer ikke eller er blevet flyttet.",
      backHome: "Tilbage til Forsiden",
    }
  }
};
